<template>

  <div class="panel-body">
    <form class="form-horizontal" v-on:submit="save($event)">

      <h4>Personal</h4>

      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-6">
          <div class="form-group">
            <label class="col-sm-4 control-label required text-left">Gender</label>
            <div class="col-sm-8">
              <v-select2 v-model="gender" :options="genders" label="name" required></v-select2>
              <label v-if="errorGender" class="error">{{ errorGender }}</label>
            </div>
          </div>
        </div>
      </div>

      <div class="row" style="margin-top: 15px">
        <div class="col-xs-12 col-sm-12 col-md-6">
          <div class="form-group">
            <label class="col-sm-4 control-label required text-left">First Name</label>
            <div class="col-sm-8">
              <input type="text" class="form-control" v-model="firstName" required>
              <label v-if="errorFirstName" class="error">{{ errorFirstName }}</label>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6">
          <div class="form-group">
            <label class="col-sm-4 control-label required text-left">Last Name</label>
            <div class="col-sm-8">
              <input type="text" class="form-control" v-model="lastName" required>
              <label v-if="errorLastName" class="error">{{ errorLastName }}</label>
            </div>
          </div>
        </div>
      </div>

      <div class="row" style="margin-top: 15px">
        <div class="col-xs-12 col-sm-12 col-md-6">
          <div class="form-group">
            <label class="col-sm-4 control-label required">Email</label>
            <div class="col-sm-8">
              <input class="form-control" v-model.trim="email" type="email" required>
              <label v-if="errorEmail" class="error">{{ errorEmail }}</label>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6">
          <div class="form-group">
            <label class="col-sm-4 control-label text-left">Phone</label>
            <div class="col-sm-8">
              <input class="form-control" v-model="phone" type="tel" min="10">
              <label v-if="errorPhone" class="error">{{ errorPhone }}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="row" style="margin-top: 15px">
        <div class="col-xs-12 col-sm-12 col-md-6">
          <div class="form-group">
            <label class="col-sm-4 control-label required">Organisation</label>
            <div class="col-sm-8">
              <input id="user_cp_name" v-model="localCompany.name" class="form-control" required
                     :class="{'has-error' : errorOrganisation, 'has-success' : errorOrganisation === false}"
                     :disabled="(value && typeof value.company !== 'undefined' && value.company !== null)">
              <typeahead v-model="queryAutocomplete" target="#user_cp_name" class="inputCompanyNameTypeahead" :async-function="getCompanyByName" ></typeahead>

              <label v-if="errorOrganisation" class="error">{{ errorOrganisation }}</label>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6">
          <div class="form-group" v-if="value && typeof value.company !== 'undefined' && value.company !== null">
            <label class="control-label text-left text-info" @click="activeTab('company-tab')" style="cursor: pointer;"><i class="fas fa-pencil-alt"></i> Edit</label>
          </div>
        </div>
      </div>

      <div class="row" style="margin-top: 15px">
        <div class="col-xs-12">
          <div class="form-group">
            <label class="col-sm-2 control-label text-left">Picture</label>
            <div class="col-sm-10">
              <label class="btn btn-primary btn-outline btn-sm file-uploads file-uploads-html5"><i class="fa fa-plus"></i>
                Choose a picture
                <input type="file" name="picture" style="display: none" accept="image/*" @change="onChangePicture($event)"></label>
              <span style="margin-left: 50px" v-if="uploadPicture">{{this.uploadPicture.name}}</span>
              <label v-if="errorPicture" class="error">{{ errorPicture }}</label>
            </div>
          </div>
        </div>
      </div>

      <div class="row" style="margin-top: 15px">
        <div class="col-xs-12">
          <div class="form-group">
            <label class="col-sm-2 control-label text-left">Preferences</label>
            <div class="col-lg-10">
              <div class="checkbox checkbox-info" id="sme">
                <input type="checkbox" style="position: absolute; opacity: 0;" name="isOpenForCollaboration" v-model="isOpenForCollaboration">
                <label class=""> I am open to be contacted for a collaboration
                  <i class="fa fa-info-circle text-info" data-toggle="popover" data-timeout="4000" :data-content="'Checking this box allows you to be more visible in the results of queries made with our search engine.'"></i>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" style="margin-top: 15px">
        <div class="col-xs-12 col-sm-12 col-md-12">
          <div class="form-group">
            <label class="col-md-2 col-sm-4 control-label">ORCID ID
              <i class="fa fa-info-circle text-info" data-toggle="popover" data-timeout="4000" :data-content="orcidText" style="cursor: pointer;"></i>
            </label>
            <div class="col-sm-8 col-md-10">
              <input type="text" class="form-control" v-model="orcid" placeholder="0000-0000-0000-0000"
                     minlength="19" maxlength="19" pattern="(\d{4}-\d{4}-\d{4}-\d{4})|(\d{4}-\d{4}-\d{4}-\d{3}X)" title="required format 0000-0000-0000-0000">
              <label v-if="errorOrcid" class="error" v-html="errorOrcid" ></label>
            </div>
          </div>
        </div>
      </div>

      <div class="row" style="margin-top: 15px"  :class="{'hide' : $user.isSe()}">
        <div class="col-xs-12 col-sm-12 col-md-12">
          <div class="form-group">
            <label class="col-sm-4 col-md-2 control-label text-left">Keywords
              <i class="fa fa-info-circle text-info" data-toggle="popover" :data-content="'These keywords describe your areas of expertise and help to identify you for collaboration'" style="cursor: pointer;"></i>
            </label>
            <div class="col-sm-8 col-md-10">
              <keywords ref="skills" v-model="skills"
                      :placeholder="'Type here keywords, ...'" :itemClassName="'expertSkills'"></keywords>
            </div>
          </div>
        </div>
      </div>

      <documents-list :user="value" v-if="value"></documents-list>

      <div class="row m-t-xl" >
        <div class="col-xs-12 text-center">
          <vue-ladda type="submit" :loading="submit.loading" class="btn btn-info" :data-style="submit.dataStyle">Save Changes</vue-ladda>
        </div>
      </div>

      <div class="modal fade hmodal-info" ref="updateEmailModal" tabindex="-1" role="dialog"  aria-hidden="true">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="color-line"></div>
            <div class="modal-header">
              <h4 class="modal-title">Update Email</h4>
            </div>
            <div class="modal-body">
              <h3>Are you sure you want to update you email: {{email}}?</h3>
              <div>
                <span>After confirm, you will be disconnected and you must confirm your new email address</span>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
              <vue-ladda type="submit" name="confirmUpdate" :loading="submit.loading" class="btn btn-info" :data-style="submit.dataStyle">Update Email</vue-ladda>
            </div>
          </div>
        </div>
      </div>
      <div class="modal fade hmodal-info" ref="showEditCompanyModal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-hidden="true">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="color-line"></div>
            <div class="modal-header">
            </div>
            <div class="modal-body">
              <h3>Would your Organisation be interested to be contacted for collaborations ?</h3>
              <div class="row m-t-lg">
                <div class="col-sm-6 text-center">
                  <router-link :to="$user.isBasic()?{name: 'Start'}:{name: 'Dashboard'}" class="btn btn-lg btn-info btn-outline" data-dismiss="modal">NO</router-link>
                </div>
                <div class="col-sm-6 text-center">
                  <button type="button" class="btn btn-lg btn-info" @click="yesButtonClicked">YES</button><br>
                <i>We are going to ask you for some additional information to increase the opportunities</i>
                </div>
              </div>
            </div>
            <div class="modal-footer">
             </div>
          </div>
        </div>
      </div>
      <div class="modal fade hmodal-info" ref="showChangeDefaultPasswordModal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-hidden="true">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="color-line"></div>
            <div class="modal-header">
              <h3>You are using a default password!</h3>
            </div>
            <div class="modal-body">
              <h4> For security reason we recommend to set a customized password by clicking the button below</h4>
              <div class="row m-t-lg">
                <div class="col-sm-6 text-center">
                  <button type="button" class="btn btn-info btn-outline" data-dismiss="modal">Remember me later</button>
                </div>
                <div class="col-sm-6 text-center">
                  <button type="button" class="btn btn-info" @click="changePassword">Change my password</button>
                </div>
              </div>
            </div>
            <div class="modal-footer">
            </div>
          </div>
        </div>
      </div>
    </form>

  </div>

</template>

<script>
import VueLadda from 'vue-ladda'
import VSelect2 from '../utils/select2'
import Keywords from './KeywordBox'
import ActionModalDocument from '../../components/modal/ActionModalDocument'
import DocumentsList from './DocumentsList'

export default {
  components: {VSelect2, VueLadda, Keywords, DocumentsList, ActionModalDocument},
  name: 'ProfilePersonalInformation',
  props: ['value'],
  data () {
    return {
      gender: null,
      lastName: null,
      firstName: null,
      email: null,
      website: null,
      phone: null,
      picture: null,
      isOpenForCollaboration: true,
      organisationName: null,
      queryAutocomplete: '',
      localCompany: {
        id: null,
        name: null,
        address1: null,
        city: null,
        zip_code: null,
        website: null,
        main_activity: null,
        country: null
      },
      orcid: null,
      skills: null,
      orcidText: '<a href="https://orcid.org/" class="text-info" target="_blank">Open Researcher and Contributor ID</a>, 16 digits',
      countries: [],
      uploadPicture: null,
      genders: [],
      showCompanyModel: false,
      submit: {
        loading: false,
        'dataStyle': 'zoom-in'
      },
      errorGender: null,
      errorLastName: null,
      errorFirstName: null,
      errorEmail: null,
      errorWebsite: null,
      errorPhone: null,
      errorPicture: null,
      errorOrcid: null,
      errorOrganisation: null
    }
  },
  watch: {
    value: function () {
      this.init()
    }
  },
  methods: {
    getResources: function () {
      this.axios.get('/genders')
        .then((response) => {
          this.genders = response.data
        })
        .catch(function (error) {
        })
    },
    init: function () {
      let user = this.value
      if (user !== null) {
        this.lastName = user.lastname
        this.firstName = user.firstname
        this.email = user.email
        this.phone = user.phone
        this.picture = user.picture
        this.website = user.website
        this.gender = user.gender
        this.localCompany = (typeof user.company !== 'undefined' && user.company !== null) ? user.company : this.localCompany

        if (user.expert && user.expert.length) {
          this.orcid = user.expert[0].orcid
          this.isOpenForCollaboration = user.expert[0].is_open_for_collaboration
          if (user.expert[0].keywords) {
            let keywords = []
            user.expert[0].keywords.forEach((kyw) => {
              if (typeof kyw.keyword.keyword !== 'undefined') keywords.push(kyw.keyword.keyword)
            })
            this.skills = keywords.join(',')
          }
        } else {
          this.showCompanyModel = true
        }
      }
    },
    save: function (e) {
      e.preventDefault()

      if (this.orcid && !this.isValidateORCID(this.orcid)) {
        this.errorOrcid = 'Please enter a <a href="https://support.orcid.org/hc/en-us/articles/360006897674-Structure-of-the-ORCID-Identifier" class="text-info" target="_blank">valid ORCID</a> like 0000-0002-1825-0097 '
        return false
      } else {
        this.errorOrcid = ''
      }

      let toBeConfirm = false

      if (!$(this.$refs.updateEmailModal).is(':visible')) {
        if (this.email !== this.value.email && this.email !== null && this.email.length !== 0) {
          $(this.$refs.updateEmailModal).modal('toggle')
          toBeConfirm = true
        }
      }

      if (toBeConfirm === false) {
        this.submit.loading = true

        this.resetErrors()

        this.savePersonalInformation().then((response) => {
          this.saveCompanyInformation().then((response) => {
            this.saveExpertInformation().then((response) => {
              if ($(this.$refs.updateEmailModal).is(':visible')) {
                $(this.$refs.updateEmailModal).modal('hide')
                this.$auth.logout()
              } else {
                this.$auth.fetch()
              }
              if (this.showCompanyModel) {
                $(this.$refs.showEditCompanyModal).modal('toggle')
              }

              this.$notify({
                type: 'success',
                title: 'Information is saved',
                placement: 'bottom-right'
              })

              this.$eventHub.$emit('refreshProfile', 'editUser')
              this.$auth.fetch()
            }).catch((error) => {
              this.setErrors(error)
            })
          }).catch((error) => {
            this.setErrors(error)
          })
        }).catch((error) => {
          this.setErrors(error)
        }).finally(() => {
          this.submit.loading = false
          if ($(this.$refs.updateEmailModal).is(':visible')) {
            $(this.$refs.updateEmailModal).modal('hide')
          }
          this.$salesMachine.editExpertProfile()
        })
      }
    },
    savePersonalInformation: function () {
      return new Promise((resolve, reject) => {
        this.upload().then(() => {
          this.axios.patch('user/' + this.value.id + '/personalInformation', {
            first_name: this.firstName,
            last_name: this.lastName,
            gender_id: this.gender.id,
            email: this.email,
            website: this.website,
            phone: this.phone,
            is_optin: true,
            picture: this.picture
          }).then((response) => {
            resolve(response)
          }).catch((error) => {
            reject(error)
          })
        }).catch((error) => {
          reject(error)
        })
      })
    },
    saveExpertInformation: function () {
      return new Promise((resolve, reject) => {
        this.axios.patch('user/' + this.value.id + '/expertInformation', {
          is_open_for_collaboration: this.isOpenForCollaboration,
          orcid: this.orcid,
          keywords: this.skills ? this.skills.split(',') : null
        }).then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    saveCompanyInformation: function () {
      return new Promise((resolve, reject) => {
        if (typeof this.value.company === 'undefined' || !this.value.company) {
          this.axios.patch('user/' + this.value.id + '/companyInformation', {
            id: this.localCompany.id ? this.localCompany.id : null,
            name: this.localCompany.name,
            address1: null,
            city: null,
            zip_code: null,
            main_activity: null,
            activity_overview: null,
            country_id: null
          }
          ).then((response) => {
            resolve(response)
          }).catch((error) => {
            reject(error)
          })
        } else {
          resolve(null)
        }
      })
    },
    onChangePicture: function (event) {
      this.uploadPicture = event.target.files[0]
    },
    upload: function () {
      return new Promise((resolve, reject) => {
        if (this.uploadPicture !== null) {
          let data = new FormData()

          data.append('files[]', this.uploadPicture)
          data.append('target', 'profile_file')
          data.append('encrypted', 1)

          this.axios.post('/files/', data)
            .then((response) => {
              this.picture = response.data.files[this.uploadPicture.name]
              resolve(response)
            })
            .catch((error) => {
              reject(error)
            })
        } else {
          resolve(null)
        }
      })
    },
    setErrors: function (error) {
      let errors = error.response.data.errors

      if (typeof errors['first_name'] !== 'undefined') {
        this.errorFirstName = errors['first_name'][0]
      } if (typeof errors['last_name'] !== 'undefined') {
        this.errorLastName = errors['last_name'][0]
      } if (typeof errors['gender_id'] !== 'undefined') {
        this.errorGender = errors['gender_id'][0]
      } if (typeof errors['email'] !== 'undefined') {
        this.errorEmail = errors['email'][0]
      } if (typeof errors['phone'] !== 'undefined') {
        this.errorPhone = errors['phone'][0]
      } if (typeof errors['picture'] !== 'undefined') {
        this.errorPicture = errors['picture'][0]
      } if (typeof errors['name'] !== 'undefined') {
        this.errorOrganisation = errors['name'][0]
      } if (typeof errors['files'] !== 'undefined') {
        this.errorPicture = errors['files'][0]
      }
    },
    resetErrors: function () {
      this.errorGender = null
      this.errorLastName = null
      this.errorFirstName = null
      this.errorEmail = null
      this.errorWebsite = null
      this.errorPhone = null
      this.errorPicture = null
      this.errorOrganisation = null
    },
    isValidateORCID: function (orcid) {
      let regex = /([0-9]{4})\-?([0-9]{4})\-?([0-9]{4})\-?([0-9]{3}[0-9X]{1})\s*$/
      return !!regex.exec(orcid)
    },
    activeTab: function (tab) {
      $(this.$refs.showEditCompanyModal).modal('hide')
      $('.nav-tabs a[href="#' + tab + '"]').tab('show')
    },
    yesButtonClicked: function () {
      this.$eventHub.$emit('isComanyOpenForCollaboration', true)
      this.activeTab('company-tab')
    },
    changePassword: function () {
      $(this.$refs.showChangeDefaultPasswordModal).modal('hide')
      this.activeTab('password-tab')
    },
    getCompanyByName: function (query, done) {
      if (query.length > 5) {
        this.axios.get('/companies/' + query + '?relations={country}')
          .then((response) => {
            let Items = []
            if (response.data) {
              response.data.forEach((company) => {
                let cleanName = company.name.replace(/<[^>]*>?/gm, '')
                let str = '<span id="item-' + company.id + '" data-id="' + company.id + '" data-name="' + cleanName + '" class="typeahead-company-item">'
                str += '<strong>' + company.name + '</strong><br><i>'
                str += (company.address ? company.address + '<br> ' : '') + (company.city ? company.city + ' ' : '') + (company.zip_code ? company.zip_code + ' ' : '')
                if (company.country && typeof company.country.name !== 'undefined' && company.country.name !== 'undefined' && company.country.name !== 'Incomplete') str += '<br>' + company.country.name
                str += '</i></span'
                Items.push(str)
              })
            }
            done(Items)
          })
          .catch((error) => {
          })
      }
    }
  },
  beforeMount () {
    this.getResources()
    this.init()
  },
  mounted () {
    $('.inputCompanyNameTypeahead').on('click', (e, datum) => {
      e.preventDefault()
      let elm = $(e.target).find('.typeahead-company-item')
      if (elm.length === 0) {
        elm = $(e.target).parents('.typeahead-company-item')
      }
      if (elm.length === 1) {
        this.queryAutocomplete = elm.attr('data-name').replace(/<[^>]*>?/gm, '')
        this.localCompany.name = elm.attr('data-name').replace(/<[^>]*>?/gm, '')
        this.localCompany.id = elm.attr('data-id')
      }
    })
    $('#user_cp_name').on('keypress', (e) => {
      if (event.keyCode === 13) {
        e.preventDefault()
        let elm = $('.inputCompanyNameTypeahead').find('li.active .typeahead-company-item')
        if (elm) {
          this.queryAutocomplete = elm.attr('data-name').replace(/<[^>]*>?/gm, '')
          this.localCompany.name = elm.attr('data-name').replace(/<[^>]*>?/gm, '')
          this.localCompany.id = elm.attr('data-id')
        }
      }
    })
    $('[data-toggle="popover"]').popover({
      trigger: 'click hover',
      placement: 'top',
      container: 'body',
      html: true
    })
    $('[data-toggle="popover"][data-timeout]').on('shown.bs.popover', function () {
      let _popover = $(this)
      let _time = $(this).data('timeout') ? $(this).data('timeout') : 3000
      setTimeout(function () {
        _popover.popover('hide')
      }, _time)
    })

    if(this.$user.hasDefaultPassword()) {
      $(this.$refs.showChangeDefaultPasswordModal).modal('show')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/ProfilePersonalInformation.vue